import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { Option } from 'next/javascripts/components/select-list';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/form-fields/member-scope-select-field/element.scss';

Component('tr-member-scope-select-field', {
  mixins: [eventListenerMixin],

  properties: {
    selected: {
      type: Boolean,
      default: false,
    },

    disabledResultTooltip: String,
  },

  ready() {
    this.selectedOptions = [];
    this.nativeField = this.querySelector('.member-scope-select-result > select');
    this.resultChips = this.querySelector('.member-scope-select-result tr-chip-set');

    this.initSelectedOptions();

    this.listenTo(this.resultChips, {
      'tr-chip-set:removal': this.handleChipRemoval.bind(this),
    });

    $(this.querySelector('.select-trigger a'))
      .on('ajax:beforeSend', this.transformSelectParams.bind(this));
  },

  setSelectedOptions(options) {
    this.selectedOptions.push(...options);
    this.selected = this.selectedOptions.length > 0;

    this.renderResultChips(options);
    this.renderNativeOptions(options);
  },

  initSelectedOptions() {
    const options = Array.from(this.nativeField.options)
      .map(opt => Option.fromElement(opt, { includeDisabled: true }));
    this.setSelectedOptions(options);
  },

  handleChipRemoval(event) {
    event.stopPropagation();

    const { value } = event.detail.dataset;
    const option = this.selectedOptions.find(opt => opt.value === value);
    if (option) this.removeSelectedOption(option);
  },

  transformSelectParams(event, xhr, config) {
    const params = JSON.parse(event.target.dataset.params);
    // eslint-disable-next-line no-param-reassign
    config.data = $.param(Object.assign(params, {
      selected_gids: this.selectedOptions.map(option => option.value).join(','),
    }));
  },

  renderResultChips(options) {
    const chipsData = options.map((option) => {
      const chipData = {
        text: option.text,
        avatar: option.data.avatar,
        icon: option.data.icon,
        data: { value: option.value },
      };

      if (option.data.disabled) {
        chipData.data.disabled = true;
        if (this.disabledResultTooltip) {
          chipData.data.tooltip = this.disabledResultTooltip;
          chipData.data.position = 'top';
        }
      }

      return chipData;
    });
    this.resultChips.addChips(chipsData);
  },

  removeSelectedOption(option) {
    const nativeOption = this.nativeField
      .querySelector(`option[value="${option.value}"]`);
    if (nativeOption) this.nativeField.removeChild(nativeOption);

    const selectedIndex = this.selectedOptions
      .findIndex(opt => opt.value === option.value);
    if (selectedIndex !== -1) {
      this.selectedOptions.splice(selectedIndex, 1);
      this.selected = this.selectedOptions.length > 0;
    }
  },

  renderNativeOptions(options) {
    Array.from(this.nativeField.querySelectorAll('option')).forEach((opt) => {
      const optionIndex = options.findIndex(option => option.value === opt.value);
      if (optionIndex !== -1) options.splice(optionIndex, 1);
    });

    if (options.length === 0) return;

    const nativeOptions = document.createDocumentFragment();
    options.forEach((option) => {
      nativeOptions.appendChild(this.renderNativeOption(option));
    });
    this.nativeField.appendChild(nativeOptions);
  },

  renderNativeOption(option) {
    const opt = document.createElement('option');
    opt.value = option.value;
    opt.selected = true;
    opt.textContent = option.text;
    return opt;
  },

  disconnected() {
    this.stopListening();
  },
});
